<template>
  <div class="total">
    <div class="pc">
      <div class="banner">
        <img src="img/zbj.png" alt="" />
        <div class="mask">
          <div class="box">Total Solutions</div>
        </div>
      </div>
      <div class="content">
        <h2>Total Solutions</h2>
        <div>
          <div class="left">
            <h3>Selection of Materials</h3>
          </div>
          <div class="right">
            we utilize EU RoHS,MFl tests and moisture tests to ensure all
            plastic <br />
            materials are maintained at the highest quality requirements. For
            <br />
            metallic materials,along with X-ray layer testing, we have added a
            full <br />
            automatic ccD test facility to ensure the mold and metallic
            materials <br />
            will be fully compatible.
          </div>
        </div>
        <div>
          <div class="left">
            <h3>Risk Assessment</h3>
          </div>
          <div class="right">
            With more than 28 years of experience,via the KENTA product <br />
            portfolio database,our engineers can provide a complete risk <br />
            assessment to our customers.
          </div>
        </div>
        <div>
          <div class="left">
            <h3>ldeas for Product Design</h3>
          </div>
          <div class="right">
            ln our goal to build long and robust relationships, we have a
            lifecycle <br />
            approach; We developm processes for new products,we provide <br />
            professional advice on raw materials, the molding process and mold
            <br />
            design used, we also provide professional advice for product <br />
            improvement, to ensure the high-quality products are produced.
          </div>
        </div>
        <div>
          <div class="left">
            <h3>Sampling</h3>
          </div>
          <div class="right">
            By ongoing testing and quality assurance, carrying out EU RoHS
            tests, <br />
            MFI test and moisture tests, we can ensure out plastic material will
            be <br />
            maintained at the highest of quality for production
          </div>
        </div>
        <div>
          <div class="left">
            <h3>lnspection</h3>
          </div>
          <div class="right">
            we understand that our customers demand the highest standards for
            <br />
            automatic inspection,we utilize special cCD mirror inspections to
            <br />
            ensure that all products meet high-quality standards.
          </div>
        </div>
        <div>
          <div class="left">
            <h3>
              Automated Production and <br />
              Quality Assurance
            </h3>
          </div>
          <div class="right">
            Across the lifecycle,from the selection of raw materials, to the
            <br />
            automation of inspections,Kenta and our customers can be sure of
            <br />
            accurate production plans and maintain the highest quality of <br />
            products.
          </div>
        </div>
        <div>
          <div class="left">
            <h3>Proactive After-sales Service</h3>
          </div>
          <div class="right">
            our relationship and service does not end at shipping; our engineers
            <br />
            maintain communication with our customers and continue to make
            <br />
            suggestions for improvement, to provide ongoing efficiency uplift.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sw: false,
    };
  },
};
</script>

<style lang="less" scoped>
.pc {
  .banner {
    height: 29vw;
    overflow: hidden;
    text-align: center;
    position: relative;
    img {
      width: 120%;
      position: relative;
      top: -15vw;
      left: -15vw;
      z-index: 0;
    }
    .mask {
      position: absolute;
      top: 0;
      background: rgba(15, 15, 15, 0.301);
      width: 100%;
      height: 100%;
      .box {
        position: absolute;
        bottom: 0;
        width: 35%;
        height: 15%;
        left: 0;
        top: 0;
        right: 0;
        margin: auto;
        color: white;
        font-size: 4vw;
        font-weight: 800;
      }
    }
  }
  .content {
    width: 70%;
    margin: 5vw auto;
    h2 {
      font-size: 2vw;
      margin-bottom: 5vw;
    }
    > div {
      padding: 2vw 0vw 4vw 0;
      width: 100%;
      border-bottom: red solid 0.1vw;
      display: flex;
      justify-content: space-between;
      .left {
        font-size: 1.5vw;
      }
      .right {
        color: grey;
        width: 60%;
        font-size: 1.2vw;
      }
    }
    & > :nth-last-child(1) {
      border-bottom: transparent solid 0.2vw;
    }
  }
}
</style>